module.exports = __webpack_public_path__ + "static/media/nodata.9f0a1d72.svg";